'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PeerId = require('peer-id');

var _require = require('interface-datastore'),
    Key = _require.Key,
    Errors = _require.Errors;

var errcode = require('err-code');

var debug = require('debug');

var log = debug('ipfs:ipns:publisher');
log.error = debug('ipfs:ipns:publisher:error');

var ipns = require('ipns');

var ERR_NOT_FOUND = Errors.notFoundError().code;
var defaultRecordLifetime = 60 * 60 * 1000; // IpnsPublisher is capable of publishing and resolving names to the IPFS routing system.

var IpnsPublisher = /*#__PURE__*/function () {
  function IpnsPublisher(routing, datastore) {
    _classCallCheck(this, IpnsPublisher);

    this._routing = routing;
    this._datastore = datastore;
  } // publish record with a eol


  _createClass(IpnsPublisher, [{
    key: "publishWithEOL",
    value: function () {
      var _publishWithEOL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(privKey, value, lifetime) {
        var peerId, record;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!privKey || !privKey.bytes)) {
                  _context.next = 2;
                  break;
                }

                throw errcode(new Error('invalid private key'), 'ERR_INVALID_PRIVATE_KEY');

              case 2:
                _context.next = 4;
                return PeerId.createFromPrivKey(privKey.bytes);

              case 4:
                peerId = _context.sent;
                _context.next = 7;
                return this._updateOrCreateRecord(privKey, value, lifetime, peerId);

              case 7:
                record = _context.sent;
                return _context.abrupt("return", this._putRecordToRouting(record, peerId));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function publishWithEOL(_x, _x2, _x3) {
        return _publishWithEOL.apply(this, arguments);
      }

      return publishWithEOL;
    }() // Accepts a keypair, as well as a value (ipfsPath), and publishes it out to the routing system

  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(privKey, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.publishWithEOL(privKey, value, defaultRecordLifetime));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function publish(_x4, _x5) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "_putRecordToRouting",
    value: function () {
      var _putRecordToRouting2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(record, peerId) {
        var errMsg, publicKey, embedPublicKeyRecord, keys;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (PeerId.isPeerId(peerId)) {
                  _context3.next = 4;
                  break;
                }

                errMsg = 'peerId received is not valid';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_INVALID_PEER_ID');

              case 4:
                publicKey = peerId._pubKey;
                _context3.next = 7;
                return ipns.embedPublicKey(publicKey, record);

              case 7:
                embedPublicKeyRecord = _context3.sent;
                keys = ipns.getIdKeys(peerId.toBytes());
                _context3.next = 11;
                return this._publishEntry(keys.routingKey, embedPublicKeyRecord || record, peerId);

              case 11:
                _context3.next = 13;
                return this._publishPublicKey(keys.routingPubKey, publicKey);

              case 13:
                return _context3.abrupt("return", embedPublicKeyRecord || record);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _putRecordToRouting(_x6, _x7) {
        return _putRecordToRouting2.apply(this, arguments);
      }

      return _putRecordToRouting;
    }()
  }, {
    key: "_publishEntry",
    value: function () {
      var _publishEntry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key, entry) {
        var errMsg, entryData, res, _errMsg;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (Key.isKey(key)) {
                  _context4.next = 4;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 4:
                _context4.prev = 4;
                // Marshal record
                entryData = ipns.marshal(entry);
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](4);
                log.error(_context4.t0);
                throw _context4.t0;

              case 12:
                _context4.prev = 12;
                _context4.next = 15;
                return this._routing.put(key.toBuffer(), entryData);

              case 15:
                res = _context4.sent;
                log("ipns record for ".concat(key.toString('base64'), " was stored in the routing"));
                return _context4.abrupt("return", res);

              case 20:
                _context4.prev = 20;
                _context4.t1 = _context4["catch"](12);
                _errMsg = "ipns record for ".concat(key.toString('base64'), " could not be stored in the routing");
                log.error(_errMsg);
                log.error(_context4.t1);
                throw errcode(new Error(_errMsg), 'ERR_PUTTING_TO_ROUTING');

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 8], [12, 20]]);
      }));

      function _publishEntry(_x8, _x9) {
        return _publishEntry2.apply(this, arguments);
      }

      return _publishEntry;
    }()
  }, {
    key: "_publishPublicKey",
    value: function () {
      var _publishPublicKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key, publicKey) {
        var errMsg, _errMsg2, res, _errMsg3;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (Key.isKey(key)) {
                  _context5.next = 4;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 4:
                if (!(!publicKey || !publicKey.bytes)) {
                  _context5.next = 8;
                  break;
                }

                _errMsg2 = 'one or more of the provided parameters are not defined';
                log.error(_errMsg2);
                throw errcode(new Error(_errMsg2), 'ERR_UNDEFINED_PARAMETER');

              case 8:
                _context5.prev = 8;
                _context5.next = 11;
                return this._routing.put(key.toBuffer(), publicKey.bytes);

              case 11:
                res = _context5.sent;
                log("public key for ".concat(key.toString('base64'), " was stored in the routing"));
                return _context5.abrupt("return", res);

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5["catch"](8);
                _errMsg3 = "public key for ".concat(key.toString('base64'), " could not be stored in the routing");
                log.error(_errMsg3);
                log.error(_context5.t0);
                throw errcode(new Error(_errMsg3), 'ERR_PUTTING_TO_ROUTING');

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[8, 16]]);
      }));

      function _publishPublicKey(_x10, _x11) {
        return _publishPublicKey2.apply(this, arguments);
      }

      return _publishPublicKey;
    }() // Returns the record this node has published corresponding to the given peer ID.
    // If `checkRouting` is true and we have no existing record, this method will check the routing system for any existing records.

  }, {
    key: "_getPublished",
    value: function () {
      var _getPublished2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(peerId, options) {
        var errMsg, checkRouting, dsVal, _errMsg4, keys, res;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (PeerId.isPeerId(peerId)) {
                  _context6.next = 4;
                  break;
                }

                errMsg = 'peerId received is not valid';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_INVALID_PEER_ID');

              case 4:
                options = options || {};
                checkRouting = options.checkRouting !== false;
                _context6.prev = 6;
                _context6.next = 9;
                return this._datastore.get(ipns.getLocalKey(peerId.id));

              case 9:
                dsVal = _context6.sent;
                return _context6.abrupt("return", this._unmarshalData(dsVal));

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](6);

                if (!(_context6.t0.code !== ERR_NOT_FOUND)) {
                  _context6.next = 19;
                  break;
                }

                _errMsg4 = "unexpected error getting the ipns record ".concat(peerId.id, " from datastore");
                log.error(_errMsg4);
                throw errcode(new Error(_errMsg4), 'ERR_UNEXPECTED_DATASTORE_RESPONSE');

              case 19:
                if (checkRouting) {
                  _context6.next = 21;
                  break;
                }

                throw errcode(_context6.t0);

              case 21:
                _context6.prev = 21;
                keys = ipns.getIdKeys(peerId.toBytes());
                _context6.next = 25;
                return this._routing.get(keys.routingKey.toBuffer());

              case 25:
                res = _context6.sent;
                return _context6.abrupt("return", this._unmarshalData(res));

              case 29:
                _context6.prev = 29;
                _context6.t1 = _context6["catch"](21);
                log.error(_context6.t1);
                throw _context6.t1;

              case 33:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 13], [21, 29]]);
      }));

      function _getPublished(_x12, _x13) {
        return _getPublished2.apply(this, arguments);
      }

      return _getPublished;
    }()
  }, {
    key: "_unmarshalData",
    value: function _unmarshalData(data) {
      try {
        return ipns.unmarshal(data);
      } catch (err) {
        throw errcode(err, 'ERR_INVALID_RECORD_DATA');
      }
    }
  }, {
    key: "_updateOrCreateRecord",
    value: function () {
      var _updateOrCreateRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(privKey, value, validity, peerId) {
        var errMsg, getPublishedOptions, record, _errMsg5, seqNumber, entryData, _errMsg6, data, _errMsg7;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (PeerId.isPeerId(peerId)) {
                  _context7.next = 4;
                  break;
                }

                errMsg = 'peerId received is not valid';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_INVALID_PEER_ID');

              case 4:
                getPublishedOptions = {
                  checkRouting: true
                };
                _context7.prev = 5;
                _context7.next = 8;
                return this._getPublished(peerId, getPublishedOptions);

              case 8:
                record = _context7.sent;
                _context7.next = 17;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](5);

                if (!(_context7.t0.code !== ERR_NOT_FOUND)) {
                  _context7.next = 17;
                  break;
                }

                _errMsg5 = "unexpected error when determining the last published IPNS record for ".concat(peerId.id);
                log.error(_errMsg5);
                throw errcode(new Error(_errMsg5), 'ERR_DETERMINING_PUBLISHED_RECORD');

              case 17:
                // Determinate the record sequence number
                seqNumber = 0;

                if (record && record.sequence !== undefined) {
                  seqNumber = record.value.toString() !== value ? record.sequence + 1 : record.sequence;
                }

                _context7.prev = 19;
                _context7.next = 22;
                return ipns.create(privKey, value, seqNumber, validity);

              case 22:
                entryData = _context7.sent;
                _context7.next = 30;
                break;

              case 25:
                _context7.prev = 25;
                _context7.t1 = _context7["catch"](19);
                _errMsg6 = "ipns record for ".concat(value, " could not be created");
                log.error(_context7.t1);
                throw errcode(new Error(_errMsg6), 'ERR_CREATING_IPNS_RECORD');

              case 30:
                _context7.prev = 30;
                // Marshal record
                data = ipns.marshal(entryData); // Store the new record

                _context7.next = 34;
                return this._datastore.put(ipns.getLocalKey(peerId.id), data);

              case 34:
                log("ipns record for ".concat(value, " was stored in the datastore"));
                return _context7.abrupt("return", entryData);

              case 38:
                _context7.prev = 38;
                _context7.t2 = _context7["catch"](30);
                _errMsg7 = "ipns record for ".concat(value, " could not be stored in the datastore");
                log.error(_errMsg7);
                throw errcode(new Error(_errMsg7), 'ERR_STORING_IN_DATASTORE');

              case 43:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[5, 11], [19, 25], [30, 38]]);
      }));

      function _updateOrCreateRecord(_x14, _x15, _x16, _x17) {
        return _updateOrCreateRecord2.apply(this, arguments);
      }

      return _updateOrCreateRecord;
    }()
  }]);

  return IpnsPublisher;
}();

IpnsPublisher.defaultRecordLifetime = defaultRecordLifetime;
exports = module.exports = IpnsPublisher;